<script>
import { mapGetters, mapActions } from 'vuex';
import http from '~/http';

export default {
  name: 'BoraDeliveryAdmin',

  computed: {
    ...mapGetters(['isLogged', 'user']),

    layout() {
      return `${this.$route.meta.layout || 'app'}-layout`;
    },
  },

  watch: {
    isLogged() {
      window.timezone = this.user.timezone;
    },
  },

  methods: {
    ...mapActions(['updateDataAuth']),
  },

  mounted() {
    if (this.isLogged) {
      http
        .get('auth/account')
        .then(({ data }) => {
          this.updateDataAuth(data.data);
        })
        .catch(() => {
          this.$alert.show(
            'Ops',
            'Houve um erro ao carregar suas informações. Tente novamente.',
            'error',
          );
        });
    }
  },
};
</script>

<template>
  <component :is="layout">
    <slide-y-up-transition mode="out-in" origin="center top">
      <router-view />
    </slide-y-up-transition>
  </component>
</template>
